function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Decimal from 'decimal.js';
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { ServiceCostType } from "../service-cost";
import { ServiceIntegrationsModel } from "../ServiceIntegrations";
import { ServiceTemplateBundlePricingTypeEnum } from "./model";
const pricingTypeFromDTO = dto => dto.type === ServiceTemplateBundlePricingTypeEnum.Fixed ? {
  type: ServiceTemplateBundlePricingTypeEnum.Fixed
} : {
  type: ServiceTemplateBundlePricingTypeEnum.Variable,
  variable: {
    cap: dto.variable.cap ? new Decimal(dto.variable.cap).div(100) : null,
    name: dto.variable.name
  }
};
const pricingTypeToDTO = pricingType => pricingType.type === ServiceTemplateBundlePricingTypeEnum.Fixed ? {
  type: ServiceTemplateBundlePricingTypeEnum.Fixed
} : {
  type: ServiceTemplateBundlePricingTypeEnum.Variable,
  variable: {
    cap: pricingType.variable.cap ? pricingType.variable.cap.mul(100).toNumber() : null,
    name: pricingType.variable.name
  }
};
const pricingTypeFromService = service => {
  switch (service.cost.pricingType) {
    case ServiceCostType.Fixed:
      return {
        type: ServiceTemplateBundlePricingTypeEnum.Fixed
      };
    case ServiceCostType.Variable:
      return {
        type: ServiceTemplateBundlePricingTypeEnum.Variable,
        variable: {
          cap: service.cost.unitCap,
          name: service.cost.unitName
        }
      };
    case ServiceCostType.Range:
      throw new Error('Invalid pricing type - Range is not supported for service bundles');
  }
};
export const fromDTO = dto => ({
  pricingType: pricingTypeFromDTO(dto.pricingType),
  services: dto.services.map(includedServiceFromDTO)
});
export const toDTO = bundle => ({
  pricingType: pricingTypeToDTO(bundle.pricingType),
  services: bundle.services.map(includedServiceToDTO)
});
export const fromService = service => ({
  pricingType: pricingTypeFromService(service),
  services: service.bundle ? service.bundle.services.map(s => ({
    id: s.serviceTemplateId || '',
    name: s.name,
    description: s.description,
    rate: s.rate,
    integrations: s.integrations
  })) : []
});
export const toServiceBundle = bundle => ({
  services: bundle.services.map(service => _objectSpread(_objectSpread({}, service), {}, {
    id: generateUniqueId('service-bundle'),
    serviceTemplateId: service.id
  }))
});
export function includedServiceFromDTO(dto) {
  return _objectSpread(_objectSpread({}, dto), {}, {
    rate: new Decimal(dto.rate).div(100),
    integrations: ServiceIntegrationsModel.fromDTO(dto.integrations)
  });
}
export function includedServiceToDTO(service) {
  return _objectSpread(_objectSpread({}, service), {}, {
    rate: service.rate.mul(100).toNumber(),
    integrations: service.integrations.toJSON()
  });
}